import React, {Component} from 'react';
import './ViewSingleCustomerOrder.css';

import {FormattedMessage} from "react-intl";
import CustomerOrderItemTable from "../CustomerOrderItemTable/CustomerOrderItemTable";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import GoogleAds from "../../../../Common/GoogleAds/GoogleAds";
import ViewSingleCustomerOrderResponsive from "./ViewSingleCustomerOrderResponsive";
// import NewOrderItemRow from "./NewOrderItemRow/NewOrderItemRow";
// import NewOrderItemHeader from "./NewOrderItemRow/NewOrderItemHeader";

class ViewSingleCustomerOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderData: [],
            orderItems: [],
            orderId: this.props.match.params.orderId,
            billOrderInfo: [],
            shipOrderInfo: [],
            userData: [],
            batchNumber: '',
            discount: 0,
            taxAmount: 0,
            items: [],
            orderTotal: 0,
            orderSubTotal: 0,
            refundedDate : "",
            refunded : false
        };
    }

    componentDidMount() {
        this.getOrder();
        this.getUser();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
            this.getOrder();
            this.getUser();
        }

    }

    getOrder = () => {

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/orders/order/' + this.state.orderId, axiosConfig)
            .then((res) => {
                // console.log("ORDER DATA DUO ===> ", res.data);
                this.setState({
                    batchNumber: res.data.order.batchNumber,
                    orderItems: res.data.order.orderItems,
                    billOrderInfo: res.data.order.orderInfo.billingAddress,
                    shipOrderInfo: res.data.order.orderInfo.shippingAddress,
                    discount: res.data.orderSummary.discount,
                    taxAmount: res.data.orderSummary.taxAmount,
                    orderTotal: res.data.orderSummary.orderTotal,
                    orderSubTotal: res.data.orderSummary.subTotal,
                    createdOn: res.data.order.createdOn.substring(0, 4) + "年" + res.data.order.createdOn.substring(5, 7) + "月" + res.data.order.createdOn.substring(8, 10) + "日",
                    // deliveryDate: res.data.order.deliveryDate.substring(0, 4) + "年" + res.data.order.deliveryDate.substring(5, 7) + "月" + res.data.order.deliveryDate.substring(8, 10) + "日"
                    deliveryDate: res.data.order.shippedDate,
                    refunded : res.data.order.refunded,
                    refundedDate : res.data.order.refundedDate

                });


            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getUser = () => {
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId)
            .then((res) => {
                this.setState({
                    userData: res.data
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    render() {
        let orderTotalFromChargeDetails = 0;
        let orderSubTotal = 0;
        let orderTax = 0;
        let orderDiscount = 0;
        let initDeliveryDate = '';
        // let initDeliveryDate="2019-04-06";
        let shippedStringDate = this.state.deliveryDate;

        return (
            <div>
                <GoogleAds slot="696274611" />
                <div className='view-single-customer-div2'>
                    <div className="admin-view-single-order-content view-single-customer-div1">
                        <div className="admin-view-single-order-div unset-width-single-customer">
                            <div className="title-1">
                                {/* <FormattedMessage id="app.admin.order.view.single.title"
                                          defaultMessage="ORDER "
                                          description=""/>*/}
                                {/*バッチ番号*/}
                                注文番号
                                &nbsp;
                                <span>#
                                    {/*{this.state.orderData.id}*/}
                                    {this.state.batchNumber}
                        </span>
                                <hr className="no-padding"/>
                            </div>

                            <div className="row">
                                <div className="row info-div-resp">
                                    <div className="col-md-4">
                                        <div className="view-details-header-div">
                                        <label className="admin-admin-view-single-order-label">
                                            <FormattedMessage id="app.admin.view.single.customer.info"
                                                              defaultMessage="Customer Information "
                                                              description=""/>
                                        </label>
                                        </div>

                                        <div>
                                            <label className="view-details-body-label">
                                                ユーザー名
                                                :&nbsp; </label>
                                            {this.state.userData.username}
                                        </div>
                                        <div>
                                            <label className="view-details-body-label">
                                                <FormattedMessage id="app.user-profile.user-profile-info.name"
                                                                  defaultMessage="Name"
                                                                  description=""/>:&nbsp; </label>
                                            {this.state.userData.firstName +" "+ this.state.userData.lastName}
                                        </div>
                                        <div>
                                            <label className="view-details-body-label">
                                                <FormattedMessage id="app.user-profile.user-profile-info.email"
                                                                  defaultMessage="Email"
                                                                  description=""/>:&nbsp; </label>
                                            {this.state.userData.email}
                                        </div>
                                        <div>
                                            <label className="view-details-body-label">
                                                <FormattedMessage id="app.user-profile.user-profile-info.phone"
                                                                  defaultMessage="Email"
                                                                  description=""/>:&nbsp; </label>
                                            {this.state.userData.phone}</div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="view-details-header-div">

                                        <label className="admin-view-single-order-label">
                                            <FormattedMessage id="app.admin.order.single.billing.address"
                                                              defaultMessage="Billing Address "
                                                              description=""/>
                                        </label>
                                        </div>
                                        <div>
                                            <div>{this.state.billOrderInfo.lastName}&nbsp;{this.state.billOrderInfo.firstName}</div>
                                            <div>〒{this.state.billOrderInfo.postalCode}</div>
                                            <div>{this.state.shipOrderInfo.province}&nbsp;{this.state.billOrderInfo.city}</div>
                                            <div>{this.state.billOrderInfo.streetAddress}&nbsp;{this.state.billOrderInfo.addressLine2}</div>
                                            <div>{this.state.billOrderInfo.cellOrMobileNumber}</div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="view-details-header-div">

                                        <label className="admin-view-single-order-label">
                                            <FormattedMessage id="app.admin.order.single.shipping.address"
                                                              defaultMessage="Shipping Address "
                                                              description=""/></label>
                                        </div>

                                        <div>{this.state.shipOrderInfo.lastName}&nbsp;{this.state.billOrderInfo.firstName}</div>
                                        <div>〒{this.state.shipOrderInfo.postalCode}</div>
                                        <div>{this.state.shipOrderInfo.province}&nbsp;{this.state.shipOrderInfo.city}</div>
                                        <div>{this.state.shipOrderInfo.streetAddress}&nbsp;{this.state.shipOrderInfo.addressLine2}</div>
                                        <div>{this.state.shipOrderInfo.cellOrMobileNumber}</div>
                                    </div>
                                </div>

                                <br/>

                            </div>
                            <hr/>

                            <div className="row">
                                <div className="col-md-6 view-details-body-div responsive-single-order-site">
                                    <label className="admin-view-single-order-label">
                                        <FormattedMessage id="app.admin.single.order.date"
                                                          defaultMessage="Order Date: "
                                                          description=""/>: &nbsp;
                                    </label>
                                    <span>

                                <text> {this.state.createdOn}</text>

                            </span>
                                    <br/>

                                    <label className="admin-view-single-order-label">
                                        <FormattedMessage id="app.admin.single.order.delivery.date"
                                                          defaultMessage="Delivery Date "
                                                          description=""/>: &nbsp;
                                    </label>
                                    <span>{ shippedStringDate && shippedStringDate!==null?
                                            shippedStringDate.substring(0, 4)+ "年" +
                                            shippedStringDate.substring(5, 7)+ "月"+
                                            shippedStringDate.substring(8, 10)+ "日": "生産中"}</span>
                                    <br/>
                                    {this.state.refunded ?
                                    <button className="btn btn-danger btn-xs" disabled={true}>
                                        <label className="admin-view-single-order-label">
                                            払い戻し日: &nbsp;
                                    </label>
                                    <span>
                                        {this.state.refundedDate.substring(0, 4)}年 {this.state.refundedDate.substring(5, 7)}月&nbsp;
                                        {this.state.refundedDate.substring(8, 10)}日
                                    </span>
                                    <br/>
                                    </button> : ""
                                    }
                                </div>

                                <div className="col-md-2 responsive-single-item"></div>
                                <div className="col-md-4 pull-right responsive-price-info-single-order">
                                    <div className="view-single-order-total">
                                        <div>
                                            <div className="col-md-5 custom-col-5 no-padding">
                                                <FormattedMessage id="app.admin.single.order.bill.sub-total"
                                                                  defaultMessage="Sub Total"
                                                                  description=""/>
                                            </div>
                                            <div className="col-md-2 custom-col-2 no-padding">:</div>
                                            <div className="col-md-5 custom-col-5 no-padding">
                                        <span className="single-order-money-values">¥ <NumberFormatter
                                            num={this.state.orderSubTotal}/></span>
                                            </div>
                                        </div>


                                        <div>
                                            <div className="col-md-5 custom-col-5 no-padding">
                                                <FormattedMessage id="app.admin.single.order.bill.discount"
                                                                  defaultMessage="Discount"
                                                                  description=""/>
                                            </div>
                                            <div className="col-md-2 custom-col-2 no-padding">:</div>
                                            <div className="col-md-5 custom-col-5 no-padding">
                                            <span className="single-order-money-values">¥ <NumberFormatter
                                                num={this.state.discount}/></span>
                                            </div>
                                        </div>


                                        <div>
                                            <div className="col-md-5 custom-col-5 no-padding">
                                                <FormattedMessage id="app.admin.single.order.bill.tax"
                                                                  defaultMessage="Consumption Tax"
                                                                  description=""/>
                                            </div>
                                            <div className="col-md-2 custom-col-2 no-padding">:</div>
                                            <div className="col-md-5 custom-col-5 no-padding">
                                            <span className="single-order-money-values">¥ <NumberFormatter
                                                num={this.state.taxAmount}/></span></div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <hr className="quotation-summary-hr"/>
                                            </div>
                                        </div>

                                        <div>
                                            <div className="col-md-5 custom-col-5 no-padding">
                                                <FormattedMessage id="app.admin.single.order.bill.total"
                                                                  defaultMessage="Bill Total"
                                                                  description=""/>
                                            </div>
                                            <div className="col-md-2 custom-col-2 no-padding">:</div>
                                            <div className="col-md-5 custom-col-5 no-padding">
                                            <span className="single-order-money-values">¥ <NumberFormatter
                                                num={this.state.orderTotal}/></span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 view-details-body-div-single responsive-view-details-body-div-single">

                                    <div className="spacer"></div>

                                    <div className="web-view">
                                        <CustomerOrderItemTable orderData={this.state.orderItems}
                                                                price={this.state.orderSubTotal}/>
                                    </div>
                                    <div className="mobile-view">
                                       <ViewSingleCustomerOrderResponsive orderData={this.state.orderItems}
                                                                          price={this.state.orderSubTotal}
                                       />
                                    </div>
                                    {/*<NewOrderItemHeader/>*/}


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default ViewSingleCustomerOrder;



// WEBPACK FOOTER //
// ./src/components/Site/Order/SingleOrder/ViewSingleCustomerOrder/ViewSingleCustomerOrder.js